import TrackingService from './tracking-service';

export default {
  bind: function (el: Element, binding: { value: any }): void {
    el.addEventListener('click', () => {
      TrackingService.pushClickEvent(binding.value);
    });
  },
};
